import React from "react";
import styled from "styled-components";
import { Form, Row, Col } from "antd";
import { Input, Button, Typography, Modal } from "../../core";
import { MixStyle } from "../../styles";
import { editTax } from "../../helper/utils/api/tax";
const Notify_Utils = require("../../helper/utils/Notification");

const layout = {
  labelCol: { span: 24 },
  wrapperCol: { span: 24 },
};

const StyledForm = styled(Form)`
  label {
    ${MixStyle.Label};
  }
`;

const EditTaxForm = ({ taxData, onSuccess, onCancel }) => {
  const [form] = Form.useForm();

  const onFinish = async (values) => {
    try {
      await editTax(values, taxData._id);
      Notify_Utils.openNotificationWithIcon("success", "Tax updated successfully");
      onSuccess();
    } catch (error) {
      Notify_Utils.openNotificationWithIcon(
        "error",
        error?.response?.data?.message || "Failed to update tax"
      );
    }
  };

  return (
    <Modal
      closable={true}
      visible={true}
      footer={false}
      maxwidth="589px"
      onCancel={onCancel}
      tittle="Update Tax"
    >
      <StyledForm
        form={form}
        {...layout}
        name="edit-tax"
        initialValues={taxData}
        onFinish={onFinish}
      >
        <Row gutter={[16, 16]} type="flex" justify="center">
          <Col md={12} sm={18} xs={24}>
            <Form.Item
              label="Tax Name"
              name="tax_name"
              rules={[{ required: true, message: "Please Input Tax Name" }]}
            >
              <Input placeholder="Tax Name" />
            </Form.Item>
          </Col>
          <Col md={12} sm={18} xs={24}>
            <Form.Item
              label="Tax Rate %"
              name="tax_rate"
              rules={[{ required: true, message: "Please Input Tax Value" }]}
            >
              <Input type="number" placeholder="Tax Rate" />
            </Form.Item>
          </Col>
          <Col md={24}>
            <Form.Item>
              <Button width="187px" bg="#404E67" type="primary" htmlType="submit">
                <Typography
                  text="Update"
                  as="h5"
                  noMargin
                  weight="bold"
                  align="center"
                  color="white"
                />
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </StyledForm>
    </Modal>
  );
};

export default EditTaxForm;
